import type { HashtagSearchResponseHashtagsItem } from './hashtagSearchResponseHashtagsItem';

export interface HashtagSearchResponse {
  hashtags?: HashtagSearchResponseHashtagsItem[];
  query?: string;
}
